import i18n from '@/i18n/config';

const t = i18n.t.bind(i18n);

export const ENERGY_UNITS = {
  MW: 'MW',
  // KW: 'KW',
};
export const energyUnits = Object.values(ENERGY_UNITS);

export const RANGE_TYPES = {
  HOUR: 'H',
  DAY: 'D',
  WEEK: 'W',
  MONTH: 'M',
  YEAR: 'Y',
};

export const FILE_FORMATS = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
};

export const ROLES_LIST = [
  {
    id: 1,
    name: 'Admin',
    value: 'admin',
    label: 'Admin',
  },
  {
    id: 2,
    name: 'Finance',
    value: 'finance',
    label: 'Finance',
  },
  {
    id: 3,
    name: 'Energy',
    value: 'energy',
    label: 'Energy',
  },
  {
    id: 4,
    name: 'Standard',
    value: 'standart',
    label: 'Standard',
  },
];

export const MONTHS_WITH_VALUES = [
  { label: t('components.months.january'), value: 1 },
  { label: t('components.months.february'), value: 2 },
  { label: t('components.months.march'), value: 3 },
  { label: t('components.months.april'), value: 4 },
  { label: t('components.months.may'), value: 5 },
  { label: t('components.months.june'), value: 6 },
  { label: t('components.months.july'), value: 7 },
  { label: t('components.months.august'), value: 8 },
  { label: t('components.months.september'), value: 9 },
  { label: t('components.months.october'), value: 10 },
  { label: t('components.months.november'), value: 11 },
  { label: t('components.months.december'), value: 12 },
];

export const LINE_DATA_KEYS = [
  'cumulativeCashFlow',
  'soh',
  'inflow',
  'outflow',
  'mcpPrice',
  'pfcPrice',
  'sfcPrice',
  'totalGeneration',
  'inflowStorage',
  'outflowStorage',
  'inflowPlant',
  'outflowPlant',
];

export enum TourSteps {
  USER_PROFILE = 0,
  HELP_SECTION = 1,
  ORGANIZATION_SECTION = 2,
  PLANTS = 3,
  CREATE_PLANT = 4,
  VIEW_PLANTS = 5,
  SCENARIOS = 6,
  CREATE_SCENARIO = 7,
  VIEW_SCENARIOS = 8,
  STORAGE_SYSTEMS = 9,
  CREATE_STORAGE_SYSTEM = 10,
  VIEW_STORAGE_SYSTEMS = 11,
  CREATE_SIMULATION = 12,
  SIMULATION_ASSETS = 13,
  SELECT_ASSET_EMPTY_FACE = 14,
  SELECT_ASSET_FILL_FACE = 15,
  REVIEW_SIMULATION_ASSETS = 16,
  RUNNING_SIMULATION = 17,
  COMPLETED_SIMULATION = 18,
  //EXAMPLE_SIMULATION = 19,
}

export enum CreateSimSteps {
  DESC_OF_SIMULATION = 0,
  ASSET_SELECTION = 1,
  OVERVIEW = 2,
}
export enum CreateReportSteps {
  SELECT_SIMULATIONS = 0,
  SELECT_METRIC = 1,
  REPORT_NAME = 2,
}
export type FilterOption = {
  value: string;
  label: string;
};
export const filterOptions: FilterOption[] = [
  { value: '1', label: 'Description' },
  { value: '2', label: 'Storage System' },
  { value: '3', label: 'Scenario' },
  { value: '4', label: 'Plants' },
];

export enum StorageType {
  BEFORE_STORAGE = 'beforeStorage',
  AFTER_STORAGE = 'afterStorage',
  STORAGE = 'storage',
}

export const STORAGE_TYPE_LABELS = {
  [StorageType.BEFORE_STORAGE]:
    'components.simReport.selectMetric.storageTypes.beforeStorage',
  [StorageType.AFTER_STORAGE]:
    'components.simReport.selectMetric.storageTypes.afterStorage',
  [StorageType.STORAGE]:
    'components.simReport.selectMetric.storageTypes.storage',
};
